import React, { useMemo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import { Button, Card, Col, Container, Form, Row } from '@themesberg/react-bootstrap';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AlertMessage } from '../../components/PageHeader';
import { adminApi } from '../../services/api';
import { Routes } from '../../routes';

function useQueryToken() {
  const location = useLocation();
  return useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get('token') || '';
  }, [location.search]);
}

export default function AdminAcceptInvite() {
  const history = useHistory();
  const tokenFromQuery = useQueryToken();
  const [token, setToken] = useState(tokenFromQuery);
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }
    if (password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }
    setLoading(true);
    try {
      await adminApi.acceptInvite(token.trim(), password);
      history.replace(Routes.AdminLogin.path);
    } catch (err) {
      setError(err.message || 'Could not accept invite');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main>
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col xs={12} md={8} lg={6}>
            <div className="d-flex align-items-center mb-4">
              <Link to={Routes.Welcome.path} className="d-flex align-items-center text-decoration-none">
                <FontAwesomeIcon icon={faShieldAlt} className="text-primary me-2" />
                <span className="fw-bold text-primary">Flowfence</span>
              </Link>
            </div>
            <Card border="light" className="shadow-sm">
              <Card.Body className="p-4 p-lg-5">
                <h3 className="mb-2">Accept admin invite</h3>
                <p className="text-gray mb-4">Set a password to activate your platform admin account.</p>
                <AlertMessage variant="danger" message={error} onClose={() => setError('')} />
                <Form onSubmit={handleSubmit}>
                  {!tokenFromQuery ? (
                    <Form.Group className="mb-3">
                      <Form.Label>Invite token</Form.Label>
                      <Form.Control
                        required
                        value={token}
                        onChange={(e) => setToken(e.target.value)}
                        placeholder="Paste invite token"
                      />
                    </Form.Group>
                  ) : null}
                  <Form.Group className="mb-3">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      required
                      type="password"
                      minLength={8}
                      autoComplete="new-password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group className="mb-4">
                    <Form.Label>Confirm password</Form.Label>
                    <Form.Control
                      required
                      type="password"
                      minLength={8}
                      autoComplete="new-password"
                      value={confirm}
                      onChange={(e) => setConfirm(e.target.value)}
                    />
                  </Form.Group>
                  <Button variant="primary" type="submit" className="w-100" disabled={loading || !token.trim()}>
                    {loading ? 'Activating…' : 'Activate account'}
                  </Button>
                </Form>
                <div className="text-center mt-4">
                  <Card.Link as={Link} to={Routes.AdminLogin.path} className="small">
                    Already activated? Sign in
                  </Card.Link>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </main>
  );
}
